<template>
  <gw-listing class="a7-unidade-negocio-listing" :refresh="refresh" :title="$t('UnidadeNegocio')"
  :default-filter-params="defaultFilterParams" modal-size="small"
  :entity-dto-rest-resource="entityDTORestResource"
  :presentation="presentation"
  >
    <gw-column field="status"/>
    <gw-column field="codigoClienteAlpha7"/>
    <gw-column field="nome"/>
    <gw-column field="CNPJ"/>
    <gw-column field="telefone"/>
    <gw-column field="cidade"/>
    <gw-column field="estado"/>

    <template slot="filterBand">
      <gw-possible-value-filter-item :display-text="$t('UnidadeNegocio.ui.filtroStatus')"
        property-name="status" :possible-values="statusPossibleValues"/>
      <gw-text-filter-item :display-text="$t('UnidadeNegocio.ui.filtroCodigoAlpha7')"
        property-name="codigoClienteAlpha7"/>
      <gw-text-filter-item :display-text="$t('UnidadeNegocio.ui.filtroRazaoSocial')"
        property-name="razaoSocial"/>
      <gw-text-filter-item :display-text="$t('UnidadeNegocio.ui.filtroCNPJ')"
        property-name="CNPJ"/>
      <gw-text-filter-item :display-text="$t('UnidadeNegocio.ui.filtroContato')"
        property-name="contato"/>
      <a7-estado-filter-item :display-text="$t('UnidadeNegocio.ui.filtroEstado')"
        property-name="estado"/>
      <a7-cidade-filter-item :display-text="$t('UnidadeNegocio.ui.filtroCidade')"
        property-name="cidade"/>
    </template>

    <template slot="editor" slot-scope="{ entity }">
      <gw-grouping-pane :title="$t('Global.ui.geral')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="pessoa" class="gw-col-6">
              <a7-pessoa-entity-chooser slot-scope="{ entity, properties }"
              v-model="entity.pessoa"
              v-bind="properties"/>
            </gw-editor-field>
          </div>
          <div class="gw-row">
            <gw-editor-field property="status" class="gw-col-3"/>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
      <gw-grouping-pane :title="$t('UnidadeNegocio.ui.editor.detalhesA7Pharma')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field class="gw-col-6"
             :presentationProperties="codigoA7PresentationProperties">
              <gw-text-field class="codigoA7" disabled :value="codigoA7(entity)"/>
            </gw-editor-field>
            <gw-editor-field property="codigo" class="gw-col-6" />
          </div>
          <div class="gw-row">
            <gw-editor-field property="movimentaEstoque" class="gw-col-6"/>
            <gw-editor-field property="adicional" class="gw-col-6"/>
          </div>
          <div class="gw-row">
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
    </template>

  </gw-listing>
</template>

<script>
/**
* @reference
*  UI0002
*/
import {
  GwListing,
  GwTextField,
  GwTextFilterItem,
  GwColumn,
  GwEditorField,
  GwGroupingPane,
  GwGridContainer,
  GwEntityChooser,
  GwPossibleValueFilterItem,
  GwEntityFilterItem,
  FilterUtilities
} from "guaxinim-web";

import UnidadeNegocioRestResource from './UnidadeNegocioRestResource'
import A7EstadoFilterItem from '../estado/A7EstadoFilterItem'
import A7CidadeFilterItem from '../cidade/A7CidadeFilterItem'
import A7PessoaEntityChooser from '../pessoa/A7PessoaEntityChooser'

export default {
  name: "a7-unidade-negocio-listing",
  components: {
    GwListing,
    GwTextField,
    GwTextFilterItem,
    GwColumn,
    GwEditorField,
    GwGroupingPane,
    GwGridContainer,
    GwEntityChooser,
    GwPossibleValueFilterItem,
    GwEntityFilterItem,
    A7EstadoFilterItem,
    A7CidadeFilterItem,
    A7PessoaEntityChooser
  },
  props: {
    defaultFilterParams: {
      type: Object,
      default: () => ({
        status: ["A"]
      })
    },
  },
  data() {
    return {
      entityDTORestResource: UnidadeNegocioRestResource,
      presentation: null,
      statusPossibleValues: [
        {description: this.$t('UnidadeNegocio.status.A'), value : 'A'},
        {description: this.$t('UnidadeNegocio.status.I'), value : 'I'}
      ],
      codigoA7PresentationProperties: {
        description : {
          key : 'UnidadeNegocio.ui.codigoA7'
        }
      }
    }
  },
  methods: {
    refresh(filterParams) {
      return this.entityDTORestResource.findDTOs(null,
        FilterUtilities.createFilterParamsString(filterParams));
    },
    search(pattern) {
      return this.entityDTORestResource.findUnidadeNegocioFinderDTO(null, pattern, 10);
    },
    findEntityByID(id) {
      return this.entityDTORestResource.findUnidadeNegocioFinderDTOByID(id);
    },
    codigoA7(entity) {
      if (!entity || !entity.grupoClienteAlpha7 || !entity.codigoClienteAlpha7) {
        return null;
      }

      return entity.grupoClienteAlpha7.toString().padStart(4, '0')+ "-" +
        entity.codigoClienteAlpha7.toString().padStart(5, '0');
    }
  },
  created() {
    this.entityDTORestResource.getDtoPresentation()
      .then(presentation => this.presentation = presentation)
      .catch((err) => this.$gw.defaultExceptionHandler.handleUnknowException(err, this));
  }
};
</script>

<style lang="scss" scoped>
  .a7-unidade-negocio-listing {
    .codigoA7 {
     width: 80px;
    }
  }
</style>
